// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".a1eyz-Logo-module_root{display:block}@media(hover:hover),(min-width:1200px){.a1eyz-Logo-module_root path{transition:fill .3s ease}.a1eyz-Logo-module_root:hover path{fill:var(--namba)}}.TV6zl-Logo-module_svg{width:auto;height:100%}.TV6zl-Logo-module_svg path{fill:var(--foreground400)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "a1eyz-Logo-module_root",
	"svg": "TV6zl-Logo-module_svg"
};
export default ___CSS_LOADER_EXPORT___;
